import './lib/firebase.js';  // Import Firebase initialization
import App from './App.svelte'
import './styles/global.css'

const app = new App({
  target: document.getElementById('app'),
})

export default app
